export const formatDate = (date: string | Date | null | undefined): string => {
  if (!date) return "";

  const parsedDate = new Date(date);

  if (isNaN(parsedDate.getTime())) return "";

  return parsedDate.toLocaleDateString("pt-BR", {
    timeZone: "UTC",
  });
};

export const toUtcDateOnly = (
  date: string | Date | null | undefined
): Date | null => {
  if (!date) return null;

  const parsedDate = new Date(date);

  if (isNaN(parsedDate.getTime())) return null;

  return new Date(
    Date.UTC(
      parsedDate.getUTCFullYear(),
      parsedDate.getUTCMonth(),
      parsedDate.getUTCDate()
    )
  );
};

export const addBusinessDays = (
  date: string | Date | null | undefined,
  businessDays: number
): Date | null => {
  const baseDate = toUtcDateOnly(date);

  if (!baseDate || businessDays < 0) return null;

  const result = new Date(baseDate);
  let remainingDays = businessDays;

  while (remainingDays > 0) {
    result.setUTCDate(result.getUTCDate() + 1);

    const dayOfWeek = result.getUTCDay();
    const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;

    if (!isWeekend) {
      remainingDays -= 1;
    }
  }

  return result;
};

export const getBusinessDaysUntil = (
  endDate: string | Date | null | undefined,
  startDate: string | Date | null | undefined = new Date()
): number | null => {
  const end = toUtcDateOnly(endDate);
  const start = toUtcDateOnly(startDate);

  if (!end || !start) return null;

  if (start.getTime() === end.getTime()) return 0;

  const direction = start < end ? 1 : -1;
  const cursor = new Date(start);
  let businessDays = 0;

  while (
    (direction === 1 && cursor.getTime() < end.getTime()) ||
    (direction === -1 && cursor.getTime() > end.getTime())
  ) {
    cursor.setUTCDate(cursor.getUTCDate() + direction);

    const dayOfWeek = cursor.getUTCDay();
    const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;

    if (!isWeekend) {
      businessDays += direction;
    }
  }

  return businessDays;
};
